<template>
  <div class="back">
    <!-- 目录遮罩 -->
    <div class="catalog" ref="homePage" @click="catalogShow = false" v-show="catalogShow  == true">
      <div class="catalog_con" @click.stop="catalogShow = true">
        <!-- 关闭按钮 -->
        <div class="closeBtn" @click.stop="catalogShow = false">
          <el-button icon="el-icon-close" circle></el-button>
        </div>
        <!-- 目录 -->
        <div class="catalog_p">
          <div
            v-for="(item,i) in catalogList"
            :key="i"
            :class="item.isChoose == true?'catalog_p_item2':'catalog_p_item'"
            @click.stop="catalogItemPar(item.pageCount,i)"
          >
            {{item.name}}
            <div
              v-for="(items,j) in item.itemList"
              :key="j"
              :class="items.isChoose == true?'catalog_p_items2':'catalog_p_items'"
              @click.stop="catalogItemChild(items.pageCount,i,j)"
            >{{items.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- ppt -->
    <div>
      <transition name="el-zoom-in-center">
        <img :src="imageSrc" alt class="pptImage" v-show="imageShow" />
      </transition>
    </div>

    <!-- 按钮组 -->
    <div class="posiTop">
      <div @click="toIndex">
        <div>
          <el-button type="warning" icon="el-icon-s-home" circle></el-button>
        </div>
      </div>
      <div class="secondBtn" @click="catalogShow = true">
        <div>
          <el-button type="primary" icon="el-icon-notebook-2" circle></el-button>
        </div>
      </div>
      <div class="secondBtn" @click="phoneFun">
        <div>
          <el-button type="info" icon="el-icon-phone" circle></el-button>
        </div>
      </div>
    </div>

    <div class="posiBot">
      <div @click="previousPage">
        <div>
          <el-button type="info" icon="el-icon-caret-top" circle :disabled="disabledPre"></el-button>
        </div>
      </div>
      <div class="secondBtn" @click="nextPage">
        <div>
          <el-button type="info" icon="el-icon-caret-bottom" circle :disabled="disabledNext"></el-button>
        </div>
      </div>
    </div>

    <!-- 电话弹窗 -->
    <el-dialog title="联系我们" :visible.sync="phoneShow" width="90%">
      <div class="phone_div" v-for="(item,i) in phoneList" :key="i" @click="callPhone(i)">
        <div>
          <i :class="item.icon"></i>
          <span>{{item.name}}</span>
        </div>
        <div>
          <span class="yellowColor">电话：{{item.num}}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    // 初始化图片路径
    this.picFun();
  },
  data() {
    return {
       phoneList:[{name:"技术支持",num:"13387262847",icon:"el-icon-edit"},{name:"商务合作",num:"15572703500",icon:"el-icon-phone-outline"}],
      phoneShow: false,
      disabledPre: false,
      disabledNext: false,
      clientHeight: "",
      pageCount: 1,
      imageSrc: "",
      catalogShow: false,
      imageShow: true,
      catalogList: [
        { name: "首页", isChoose: false, pageCount: 1, itemList: [] },
        {
          name: "1.总体设计",
          isChoose: false,
          pageCount: 3,
          itemList: [
            { name: "1.1系统概述", isChoose: false, pageCount: 3 },
            { name: "1.2总体拓扑图", isChoose: false, pageCount: 3 },
            { name: "1.3建设内容介绍", isChoose: false, pageCount: 4 },
            { name: "1.4通信链路设计", isChoose: false, pageCount: 5 },
            { name: "1.5总结", isChoose: false, pageCount: 6 }
          ]
        },
        {
          name: "2.系统详细设计方案 ",
          isChoose: false,
          pageCount: 7,
          itemList: [
            { name: "2.1基础支撑功能建设", isChoose: false, pageCount: 7 },
            { name: "2.2应急通信保障", isChoose: false, pageCount: 13 },
            { name: "2.3指挥调度", isChoose: false, pageCount: 29 }
          ]
        }
      ]
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
     callPhone(i){
       window.location.href = `tel:`+this.phoneList[i].num
    },
    phoneFun() {
      this.phoneShow = true;
    },
    picFun() {
      this.imageSrc = require("../../assets/images/word/" +
        this.pageCount +
        ".png");
    },
    // 上一页
    previousPage() {
      this.imageShow = false;
      console.log();
      if (this.pageCount > 1) {
        this.pageCount--;
        this.imageSrc = require("../../assets/images/word/" +
          this.pageCount +
          ".png");
      } else {
        this.$message("这是首页");
      }

      setTimeout(() => {
        this.imageShow = true;
      }, 500);
    },
    // 下一页
    nextPage() {
      this.imageShow = false;
      if (this.pageCount < 40) {
        this.pageCount++;
        this.imageSrc = require("../../assets/images/word/" +
          this.pageCount +
          ".png");
      } else {
        this.$message("这是最后一页了");
      }

      setTimeout(() => {
        this.imageShow = true;
      }, 500);
    },
    catalogItemPar(c, index) {
      if (index == 0) {
        this.imageShow = false;
        console.log(c);
        this.pageCount = c;
        this.imageSrc = require("../../assets/images/word/" +
          this.pageCount +
          ".png");
        this.catalogShow = false;
        setTimeout(() => {
          this.imageShow = true;
        }, 500);
      }
    },
    catalogItemChild(c, index, jIndex) {
      console.log(c);
      this.imageShow = false;
      for (var i = 0; i < this.catalogList.length; i++) {
        // this.catalogList[i].isChoose = false;
        for (var j = 0; j < this.catalogList[i].itemList.length; j++) {
          this.catalogList[i].itemList[j].isChoose = false;
        }
      }
      this.catalogList[index].itemList[jIndex].isChoose = true;
      console.log(c);
      this.pageCount = c;
      this.imageSrc = require("../../assets/images/word/" +
        this.pageCount +
        ".png");
      this.catalogShow = false;
      setTimeout(() => {
        this.imageShow = true;
      }, 500);
    },

    toIndex() {
      this.$router.push({ path: "/" });
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.pptImage {
  width: 100%;
  z-index: 888;
}
.indexBtn {
  position: fixed;
  top: 5%;
  right: 3%;
}
.catalogBtn {
  position: fixed;
  top: 12%;
  right: 3%;
}
.previousBtn {
  position: fixed;
  bottom: 5%;
  right: 3%;
}
.nextBtn {
  position: fixed;
  bottom: 12%;
  right: 3%;
}
.catalog {
  width: 100%;
  background-color: rgba(00, 00, 00, 0.5);
  position: fixed;
  z-index: 999;
}
.catalog_con {
  width: 90%;
  height: 100%;
  margin-left: 10%;
  background-color: rgba(33, 33, 33, 1);
}
.closeBtn {
  position: absolute;
  top: 3%;
  right: 3%;
}
.catalog_p {
  width: 80%;
  margin: 0 auto;
  color: #fff;
  font-size: 22px;
  padding-top: 15%;
}
.catalog_p_item {
  margin-top: 20px;
}
.catalog_p_item2 {
  margin-top: 20px;
  color: #f98329;
}
.catalog_p_items {
  margin-top: 20px;
  font-size: 16px;
  margin-left: 20px;
}
.catalog_p_items2 {
  margin-top: 20px;
  color: #f98329;
  font-size: 16px;
  margin-left: 20px;
}
.secondBtn {
  margin-top: 15px;
}
.phone_div{
  width: 90%;
  margin: 0 auto;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;
  margin-top: 10px;
}
.yellowColor{
  color: #f98329;
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phone_word.vue